import MDModal from 'components/MDModal';
import React, { useState, useEffect } from 'react';
import "../style.css";
import { useAgencyInfo } from 'context/agency';
import ReactSelect from 'react-select';

import SoftBox from "components/SoftBox";
import Grid from "@mui/material/Grid";
import { Tooltip } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import { usePromptCategoriesByIds } from 'queries/promptCategories';
import { useUpdateTemplate } from 'queries/prompts';

function Edit({ handleRefresh, openModel, onclosemodel, data, loadcategory }) {
  console.log("Data", data)
  const [agency] = useAgencyInfo();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [waiting, setWaiting] = useState(false);

  const [formData, setFormData] = useState({
    _id: "",
    name: '',
    instructions: "",
    temperature: "",
    top_p: "",
    api_type: "",
    template_id: ""

  });
  console.log("Form Data", formData)

  useEffect(() => {
    if (data) {
      setFormData({
        _id: data._id || '',
        name: data.name || '',
        instructions: data.template.instructions || '',
        temperature: data.template.temperature || 0,
        top_p: data.template.top_p || 0,
        api_type: data.apiType || '',
        template_id: data.template.id || '',

      });
    }
  }, [data]);

  const { data: categoryData } = usePromptCategoriesByIds(data?.categories);
  const categories = categoryData?.data || [];

  useEffect(() => {
    if (categoryData?.selectedcategory) {
      setSelectedOptions(categoryData.selectedcategory);
    }
  }, [categoryData]);





  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCCInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }

    // setContentCreativity(tempSliderValue);
    setFormData({ ...formData, [event.target.name]: tempSliderValue })
  };

  const handleBtInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input1");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }
    // setBtgen(tempSliderValue);
    setFormData({ ...formData, [event.target.name]: tempSliderValue })
  };

  const handleSelectChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    // setApiType(e.target.value)
  };

  const { mutateAsync: updateTemplate } = useUpdateTemplate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWaiting(true);
    loadcategory();
    const payload = {
      _id: formData._id,
      name: formData.name,
      instructions: formData.instructions,
      model: "openai/gpt-4o",
      temperature: formData.temperature,
      top_p: formData.top_p,
      template_id: formData.template_id
    };
    const { response } = await updateTemplate(payload);
    setWaiting(false);
    if (response) {
      onclosemodel();
    }
  };
  const handleCategoryChange = async (selected) => {
    setSelectedOptions(selected);
  };
  return (
    <div>
      {openModel &&

        <div className="modal-zz-confirm text-left">
          <div className="p-2 scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
            <h2 className='text-black text-left font-14' style={{ fontWeight: "700" }}> Update Template </h2>
            <span className='crossison' onClick={onclosemodel}>X</span>
            <SoftBox component="form" onSubmit={handleSubmit}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <SoftBox className="mt-2">
                    <label className="text-black">Template Name</label>
                    <input className="form-control-agust"
                      placeholder="Template Name"
                      name='name'
                      value={formData.name}
                      onChange={handleChange}
                      required />
                  </SoftBox>
                </Grid>

                <Grid item xs={12} style={{ marginTop: '14px' }}>
                  <SoftBox className="mt-2">

                    <label className="text-black" style={{ display: "flex", alignItems: "center", position: "relative", width: "fit-content" }} >
                      <span>Template Purpose</span>
                    </label>

                    <textarea className="form-control-agust"
                      name="instructions"
                      rows={4} style={{ width: "100%", padding: '14px' }}
                      value={formData.instructions}
                      required
                      onChange={handleChange}
                    ></textarea>
                  </SoftBox>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }} >
                      <span>Content Creativity</span>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input type="range" name="temperature" value={formData.temperature} min="0" max="2" step={'0.01'} onChange={handleCCInputChange} className="range-input" />
                      <input
                        type="number"
                        name="temperature"
                        value={formData.temperature}
                        min="0"
                        max="2"
                        step="0.01"
                        onChange={(event) => handleCCInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black"
                        }}
                        className="height_25 bg_transparent removeControl"
                      />
                    </div>
                  </SoftBox>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }} ><span>Balance Text Generation</span>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input type="range" name="top_p" value={formData.top_p} min="0" max="1" step={'0.01'} onChange={handleBtInputChange} className="range-input1" />

                      <input
                        type="number"
                        name="top_p"
                        value={formData.top_p}
                        min="0"
                        max="1"
                        step="0.01"
                        onChange={(event) => handleBtInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black"
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </SoftBox>
                </Grid>
              </Grid>

              <SoftBox mt={4}>
                <button className="savebtn-setting w-100 position-relative" type="submit" disabled={waiting}>
                  {waiting && (
                    <div class="spinner" style={{
                      width: '16px',
                      height: '16px',
                      display: "inline-block",
                      marginRight: "8px"
                    }}></div>
                  )}
                  Update Template
                </button>
              </SoftBox>
            </SoftBox>
          </div>
        </div >
      }

    </div>
  );
}

export default Edit;
